import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { EMPTY, expand, from, map, mergeMap, Observable, reduce } from 'rxjs';
import { environment } from '../../environments/environment';
import { USER_ID_PLACEHOLDER } from '../auth/user-id.interceptor';
import { Charger, ChargerSessionHistoryResponse, SessionHistory } from '../models';

@Injectable({
  providedIn: 'root'
})
export class HistoryService {
	private http = inject(HttpClient);

	constructor() { }

	getSessionHistoryPage(timeBegin: number, timeEnd: number, charger?: Charger | null, nextToken?: string): Observable<ChargerSessionHistoryResponse> {
		let params = new HttpParams()
			.set('beginTime', timeBegin)
			.set('endTime', timeEnd);
		if (nextToken) {
			params = params.set('nextToken', nextToken);
		}
		if (charger) {
			params = params.set('serialNumber', charger.serialNumber);
		}
		return this.http
			.get<ChargerSessionHistoryResponse>(
				`${environment.api}/users/${USER_ID_PLACEHOLDER}/session-history`, 
				{ params }
			);
	}


	getSessionHistory( timeBegin: number, timeEnd: number, chargers: Charger[]): Observable<SessionHistory[]> {
		return from(chargers).pipe(
			mergeMap(charger =>
				this.getSessionHistoryPage(timeBegin, timeEnd, charger).pipe(
					expand(response =>
						response.nextToken
							? this.getSessionHistoryPage(
									timeBegin,
									timeEnd,
									charger,
									response.nextToken
							)
							: EMPTY
					),
					map(response => response.chargeSessions),
					reduce((all, page) => all.concat(page), [] as SessionHistory[])
				)
			),
			reduce((allChargers, chargerSessions) => allChargers.concat(chargerSessions), [] as SessionHistory[]),
			map(allSessions => allSessions.sort((a, b) => a.begin.time - b.begin.time))
		);
	}
}
